import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/anime';

const articleImages = [
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20summer%20festival%20scene%20with%20fireworks%20and%20colorful%20booths%2C%20warm%20coral%20and%20orange%20evening%20sky%2C%20festive%20atmosphere%2C%20clean%20flat%20art%20style%2C%20simple%20composition&width=600&height=400&seq=article-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20traditional%20Japanese%20castle%20at%20night%20with%20moon%20and%20floating%20lanterns%2C%20warm%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20flat%20art%20style%2C%20simple%20composition&width=600&height=400&seq=article-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20donghua%20style%20illustration%20of%20epic%20celestial%20palace%20floating%20in%20clouds%20with%20golden%20light%2C%20warm%20coral%20and%20amber%20tones%2C%20majestic%20atmosphere%2C%20clean%20flat%20art%20style&width=600&height=400&seq=article-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20cozy%20reading%20nook%20with%20bookshelf%20and%20warm%20lamp%20light%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20peaceful%20atmosphere%2C%20clean%20flat%20art%20style&width=600&height=400&seq=article-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20dramatic%20battle%20scene%20with%20energy%20effects%2C%20warm%20orange%20and%20red%20dynamic%20lighting%2C%20intense%20atmosphere%2C%20clean%20flat%20art%20style%2C%20simple%20composition&width=600&height=400&seq=article-05&orientation=landscape',
];

export default function ArticlesSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新资讯
          </h2>
          <p className="text-sm text-foreground-500 mt-1">掌握动漫圈最新动态</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {latestArticles.slice(0, 3).map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
              <img
                src={articleImages[index]}
                alt={article.title}
                title={article.title + ' - 奶片动漫'}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full font-medium whitespace-nowrap">
                  {article.category}
                </span>
                <span className="text-xs text-foreground-400">{article.date}</span>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 line-clamp-2">
                {article.summary}
              </p>
            </div>
          </Link>
        ))}
      </div>

      {latestArticles.length > 3 && (
        <div className="mt-6 space-y-3">
          {latestArticles.slice(3).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex items-center gap-4 p-4 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors line-clamp-1">
                  {article.title}
                </h4>
              </div>
              <span className="w-6 h-6 flex items-center justify-center text-foreground-400 flex-shrink-0">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}